import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioColorGroupComponent } from './components/radio-color-group.component';
import { FormsModule } from '@angular/forms';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';

@NgModule({
  declarations: [RadioColorGroupComponent],
  imports: [CommonModule, FormsModule, MatRadioModule],
  exports: [RadioColorGroupComponent],
})
export class RadioColorGroupModule {}
